/* One ten-hour window per browser; never restart expired or unavailable storage. */
(() => {
  if (window.avelunoListicle3Countdown) return;
  window.avelunoListicle3Countdown = true;
  const key = 'aveluno:listicle3:ten-hour-window:v1';
  const duration = 10 * 60 * 60 * 1000;
  const active = new Map();
  function start(root = document) {
    for (const offer of root.querySelectorAll('[data-avl3-countdown]')) {
      if (active.has(offer)) continue;
      let deadline;
      try {
        const saved = localStorage.getItem(key);
        deadline = saved === null ? Date.now() + duration : Number(saved);
        if (!Number.isFinite(deadline) || deadline <= 0 || deadline > Date.now() + duration) continue;
        if (saved === null) localStorage.setItem(key, String(deadline));
      } catch { continue; }
      const panel = offer.querySelector('.avl3-countdown');
      const clock = panel.querySelector('.avl3-countdown-clock');
      const label = panel.querySelector('.avl3-countdown-label');
      const hours = panel.querySelector('[data-hours]');
      const minutes = panel.querySelector('[data-minutes]');
      const seconds = panel.querySelector('[data-seconds]');
      const update = () => {
        if (!offer.isConnected) { clearInterval(active.get(offer)); active.delete(offer); return; }
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        panel.hidden = false;
        if (remaining === 0) {
          clock.hidden = true;
          label.textContent = offer.dataset.expired;
          label.setAttribute('role', 'status');
          offer.classList.add('avl3-offer--expired');
          offer.querySelector('.avl3-button').textContent = offer.dataset.expiredCta;
          clearInterval(active.get(offer)); active.delete(offer);
          return;
        }
        hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
        minutes.textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
        seconds.textContent = String(remaining % 60).padStart(2, '0');
      };
      active.set(offer, setInterval(update, 1000));
      update();
    }
  }
  start();
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [offer, timer] of active) {
      if (event.target.contains(offer)) { clearInterval(timer); active.delete(offer); }
    }
  });
})();
